/* src/app/shared/components/complaints/complaints.component.scss */
.main-div {
  padding-left: 1em;
}
.inline-elements p,
.inline-elements a {
  display: inline;
  margin-right: 3px;
}
/*# sourceMappingURL=complaints.component.css.map */
